import React from "react";
import { Button } from "@mui/material";
import { motion } from "framer-motion";

/**
 * Botón con micro-interacciones avanzadas
 * - Ripple effect mejorado
 * - Scale on hover
 * - Tap animation
 * - Gradient hover
 */
const AnimatedButton = React.memo(
  ({
    children,
    variant = "contained",
    color = "primary",
    onClick,
    fullWidth = false,
    size = "medium",
    withGradient = false,
    ...props
  }) => {
    const buttonVariants = {
      rest: {
        scale: 1,
        transition: { duration: 0.2, ease: "easeInOut" },
      },
      hover: {
        scale: 1.05,
        transition: {
          duration: 0.3,
          ease: [0.25, 0.46, 0.45, 0.94],
        },
      },
      tap: {
        scale: 0.95,
        transition: { duration: 0.1 },
      },
    };

    return (
      <motion.div
        variants={buttonVariants}
        initial="rest"
        whileHover="hover"
        whileTap="tap"
        style={{ display: fullWidth ? "block" : "inline-block", width: fullWidth ? "100%" : "auto" }}
      >
        <Button
          variant={variant}
          color={color}
          onClick={onClick}
          fullWidth={fullWidth}
          size={size}
          sx={{
            position: "relative",
            overflow: "hidden",
            background: withGradient
              ? "linear-gradient(45deg, #0B72B9 0%, #FFBA60 100%)"
              : undefined,
            backgroundSize: withGradient ? "200% 200%" : undefined,
            transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            "&:hover": {
              boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
              backgroundPosition: withGradient ? "100% 50%" : undefined,
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: "50%",
              left: "50%",
              width: 0,
              height: 0,
              borderRadius: "50%",
              background: "rgba(255, 255, 255, 0.3)",
              transform: "translate(-50%, -50%)",
              transition: "width 0.6s, height 0.6s",
            },
            "&:active::before": {
              width: "300px",
              height: "300px",
            },
          }}
          {...props}
        >
          {children}
        </Button>
      </motion.div>
    );
  }
);

AnimatedButton.displayName = "AnimatedButton";

export default AnimatedButton;
